// React import not needed with new JSX transform

export interface TransformTooltipProps {
  visible: boolean
  position: { x: number; y: number }
  mode: 'translate' | 'rotate' | 'scale' | null
  axis: 'x' | 'y' | 'z' | 'xy' | 'xz' | 'yz' | 'xyz' | null
  value: number | { x?: number; y?: number; z?: number }
}

export function TransformTooltip({ visible, position, mode, axis, value }: TransformTooltipProps) {
  if (!visible || !mode) return null

  const formatValue = (val: number, type: 'translate' | 'rotate' | 'scale') => {
    switch (type) {
      case 'translate':
        return `${(val * 1000).toFixed(1)}mm` // Convert to millimeters
      case 'rotate':
        return `${(val * 180 / Math.PI).toFixed(1)}°` // Convert radians to degrees
      case 'scale':
        return `${val.toFixed(3)}x`
      default:
        return val.toFixed(3)
    }
  }

  const getDisplayText = () => {
    if (typeof value === 'number') {
      return `${axis?.toUpperCase()}: ${formatValue(value, mode)}`
    } else if (typeof value === 'object' && value) {
      const parts = []
      if (value.x !== undefined) parts.push(`X: ${formatValue(value.x, mode)}`)
      if (value.y !== undefined) parts.push(`Y: ${formatValue(value.y, mode)}`)
      if (value.z !== undefined) parts.push(`Z: ${formatValue(value.z, mode)}`)
      return parts.join(', ')
    }
    return ''
  }

  return (
    <div
      className="transform-tooltip"
      style={{
        position: 'fixed',
        left: position.x + 10,
        top: position.y - 30,
        background: 'rgba(0, 0, 0, 0.8)',
        color: 'white',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        fontFamily: 'monospace',
        pointerEvents: 'none',
        zIndex: 1000,
        whiteSpace: 'nowrap',
      }}
    >
      {getDisplayText()}
    </div>
  )
} 